export const FAQ = (props) => {
  return (
    <div id="faq" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>{props.data ? props.data.title : 'Korduma Kippuvad Küsimused'}</h2>
          <p>{props.data ? props.data.paragraph : 'Loading...'}</p>
        </div>
        <div className="row">
          <div className="col-md-8 col-md-offset-2">
            {props.data ? 
              props.data.questions.map((item, index) => (
                <div className="faq-item" key={`faq-${index}`}>
                  <h3>{item.question}</h3>
                  <p>{item.answer}</p>
                </div>
              ))
              : 'Loading...'}
          </div>
        </div>
      </div>
    </div>
  );
}